const helpUrl = 'https://docs.haust.network/'

export const uniswapUrls = {
  // Help and web articles/items
  helpUrl,
}

